export const loadState = () => {
  try {
    const serializedState = localStorage.getItem('FMLState');
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    return undefined;
  }
};
export const saveState = (state) => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem('FMLState', serializedState);
  } catch (err) {
    console.log(err);
  }
};
